import { useCallback, useState } from "react";
import { Accordion, Card } from "react-bootstrap";

export default function TaxiFaq({faqData}) {
  const [activeKey, setActiveKey] = useState("0");

  const handleToggle = useCallback(
    (key) => {setActiveKey((prevKey) => (prevKey === key ? null : key));
    },[]);
    
  return (
    <section className="carpool-faq">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h4 className="heading center-heading">
              frequently
              <span className="gradiant-color"> asked questions</span>
            </h4>
            <Accordion activeKey={activeKey} className="faq-accord">
              {faqData.map(({ id, question, answer }) => (
                <Card key={id} className={activeKey === id ? "active" : ""}>
                  <Card.Header>
                    <Accordion.Item eventKey={id}>
                      <Accordion.Header as="h4" onClick={() => handleToggle(id)}>
                        <label>{question}</label>
                        <span>{activeKey === id ? "−" : "+"}</span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <p>{answer}</p>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Card.Header>
                </Card>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
